import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const buttonContainerStyle = {
  float: 'right'
};

const HoldReviewDialog = ({
  isOpen,
  closeDialog,
  encounterId,
  submitHoldReview
}) => {
  const [comment, setComment] = useState();

  const handleCommentChange = e => {
    setComment(e.target.value);
  };

  const submitClick = () => {
    submitHoldReview(encounterId, comment);
    closeDialog();
    setComment('');
  };

  const checkCommentPresent = () => {
    if (comment === '' || comment === undefined) return "disabled";
    return undefined;
  };

  const buttonDisabled = checkCommentPresent();

  return (
    <Dialog
      open={isOpen}
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={rootDialogStyle}>
        <h4>Comment</h4>
        <textarea value={comment} onChange={handleCommentChange} cols="96" rows="8" maxLength="2500" />
        <div style={buttonContainerStyle}>
          <button onClick={submitClick} disabled={buttonDisabled}>
            Submit
          </button>
          <button onClick={closeDialog}>
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

HoldReviewDialog.propTypes = {};

export default HoldReviewDialog;
